import {IController, IDeferred, IModule, IOnChangesObject, IQService} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {RevisjonsloggRessurs} from "felles/tjenester/ressurser/RevisjonsloggRessurs";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";

const css = require('./endringshendelser.scss');

export class GruppeEndringshendelserKontroller implements IController {
    static registrerKomponent(angular: IModule) {
        angular
          .component('wmGruppeEndringshendelser', {
              bindings: {gruppe: "<"},
              controller: GruppeEndringshendelserKontroller.forInjisering(),
              template: require('./endringshendelser.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.ng.$q,
            WebNavigasjon.regNavn,
            RevisjonsloggRessurs.regNavn,
            GruppeEndringshendelserKontroller
        ]
    }

    constructor(private $q: IQService,
                private navigasjon: WebNavigasjon,
                private revisjonsloggRes: RevisjonsloggRessurs) {
        this.defferedGruppe = this.$q.defer<l.GruppeModell>();

    }

    gruppe: l.GruppeModell; //settes via bindings/$onChanges

    // returnerers i lasthendeleser, siden gruppe ikke er satt når denne kalles første gang.
    private defferedGruppe: IDeferred<l.GruppeModell>;

    lastHendelser(offset: number, antall: number) {
        return this.defferedGruppe.promise
          .then(gruppe => this.revisjonsloggRes.finnEndringerKnyttetTilGruppe(this.gruppe.id, offset, antall).$promise);
    }

    $onChanges(changes: IOnChangesObject) {
        dersomChangesInneholder(changes, "gruppe", (gruppe) => {
            this.defferedGruppe.resolve(gruppe)
        });
    }

    //hjelpemetoder

}

